import React, { useState, useRef, useEffect, useContext } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import "./ProfileSettings.css";
import CommonBreadcrumb from "./../../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import { GETProfile, Update_Profile } from "../../../features/admin/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../utils/context";
import { AllCity } from "../../../features/admin/common/Slice";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import SuccessModal from "../../common_components/common_modal/profile_succes_modal/ProfileSucces";
import { IDS } from "../../../utils/IDS";

const ProfileSettings = () => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const profilePicFile = watch("profile_pic");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userdata } = useContext(Context);

  const profileDetails = useSelector(
    (state) => state?.auth?.login?.getCustomerData,
  );

  const all_cities = useSelector((state) => state?.common?.all_cities);

  useEffect(() => {
    dispatch(GETProfile());
    dispatch(AllCity());
  }, [dispatch]);

  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Profile Settings" },
  ];

  const fileInputRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [saveAddress, setSaveAddress] = useState(
    localStorage.getItem("saveAddress") === "true",
  );

  const handleEditClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     setProfileImage(imageUrl);
  //   }
  // };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfilePhoto(file);
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
    }
  };

  const [isInitialized, setIsInitialized] = useState(false);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    if (!isInitialized && profileDetails && all_cities?.length) {
      setValue("name", profileDetails?.name);
      setValue("email", profileDetails?.email);
      setValue("address1", profileDetails?.user_address?.address1);
      setValue("pincode", profileDetails?.user_address?.pincode);

      const city = all_cities.find(
        (c) => c.value === profileDetails?.user_address?.city_id,
      );

      if (city) {
        setValue("city_id", city);
      }

      setIsInitialized(true);
    }
  }, [profileDetails, all_cities, isInitialized, setValue]);

  const onSubmit = async (data) => {
    try {
      setApiError(""); // reset previous error

      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("address1", data.address1);
      formData.append("city_id", data.city_id?.value);
      formData.append("pincode", data.pincode);

      if (data.profile_photo?.[0]) {
        formData.append("profile_photo", data.profile_photo[0]);
      }

      const res = await dispatch(Update_Profile(formData)).unwrap();

      // ✅ SUCCESS
      if (res?.success) {
        dispatch(GETProfile());
        setShowModal(true);
      }
    } catch (err) {
      // ❌ ERROR HANDLING
      // setApiError(err?.message || "Something went wrong");
      setApiError(err || "Something went wrong");
    }
  };

  const cityOptions = [
    { label: "Pune", value: 1 },
    { label: "Mumbai", value: 2 },
    { label: "Kolhapur", value: 3 },
    { label: "Solapur", value: 4 },
    { label: "Bangalore", value: 5 },
  ];

  useEffect(() => {
    localStorage.setItem("saveAddress", saveAddress);
  }, [saveAddress]);

  return (
    <section className="profile-setting-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <div className="profile-wrapper">
        <Container>
          <p className="text-center text-muted mb-5">
            Update your personal details & manage your account preferences.
          </p>

          <Card className="profile-card shadow-sm border-0">
            {/* Avatar */}
            <div className="profile-image-wrapper">
              <div className="first-border">
                <div className="second-border">
                  <div className="profile-image">
                    {profileImage ? (
                      <img src={profileImage} alt="Profile" />
                    ) : profileDetails?.profile_photo ? (
                      <img
                        src={`${IDS.IMG_URL}${profileDetails.profile_photo}`}
                        alt="Profile"
                      />
                    ) : userdata?.name ? (
                      userdata.name
                        .split(" ")
                        .map((word) => word[0])
                        .join("")
                        .toUpperCase()
                        .slice(0, 2)
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="edit-icon" onClick={handleEditClick}>
                <FontAwesomeIcon icon={faPen} />
              </div>
              <input
                type="file"
                accept="image/*"
                hidden
                ref={fileInputRef}
                onChange={(e) => {
                  handleImageChange(e);
                  setValue("profile_photo", e.target.files);
                }}
              />

              {errors?.profile_photo && (
                <div className="text-danger text-center mt-2">
                  {errors?.profile_photo?.message}
                </div>
              )}
            </div>

            <Card.Body className=" profile-card-body">
              <Form onSubmit={handleSubmit(onSubmit)}>
                {" "}
                <Form.Group className="mb-3">
                  <Form.Label>Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    value={profileDetails?.mobile_number || ""}
                    className="rounded-pill"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="eg. sarah jamdar"
                    className="rounded-pill"
                    // ✅ Prevent typing numbers & symbols
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(
                        /[^A-Za-z\s]/g,
                        "",
                      );
                    }}
                    {...register("name", {
                      required: "Name is required",

                      maxLength: {
                        value: 100,
                        message: "Name cannot exceed 100 Characters",
                      },

                      // ✅ Validation (extra safety)
                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Only alphabets are allowed",
                      },
                    })}
                  />

                  {errors?.name && (
                    <Form.Text className="text-danger">
                      {errors?.name?.message}
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email Address </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="eg. sarahjamdar@example.com"
                    className="rounded-pill"
                    onInput={(e) => {
                      let value = e.target.value;

                      // remove spaces
                      value = value.replace(/\s/g, "");

                      // allow only valid email characters
                      value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

                      // prevent multiple @
                      const parts = value.split("@");
                      if (parts.length > 2) {
                        value = parts[0] + "@" + parts.slice(1).join("");
                      }

                      e.target.value = value.toLowerCase();
                    }}
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/,
                        message: "Enter a valid email address",
                      },

                      validate: (value) => {
                        if (value.startsWith(".") || value.endsWith(".")) {
                          return "Email cannot start or end with dot";
                        }
                        if (value.includes("..")) {
                          return "No consecutive dots allowed";
                        }
                        if (!value.includes("@")) {
                          return "Email must contain @";
                        }
                        return true;
                      },
                    })}
                  />
                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors?.email?.message}
                    </Form.Text>
                  )}
                </Form.Group>
                {/* <Form.Group className="mb-3">
                  <Form.Label>Street Address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Street Address"
                    className="rounded-4"
                    {...register("address1", {
                      required: "Street Address is required",

                      maxLength: {
                        value: 300,
                        message: "Street Address cannot exceed 300 characters",
                      },
                    })}
                  />
                  {errors?.address1 && (
                    <Form.Text className="text-danger">
                      {errors?.address1?.message}
                    </Form.Text>
                  )}
                </Form.Group> */}
                {/* <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>

                      <Controller
                        name="city_id"
                        control={control}
                        rules={{ required: "City is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={all_cities}
                            value={field.value}
                            onChange={(val) => field.onChange(val)}
                            onInputChange={(val) => {
                              dispatch(AllCity(val));
                            }}
                          />
                        )}
                      />
                      {errors?.city_id && (
                        <Form.Text className="text-danger">
                          {errors?.city_id?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Zipcode</Form.Label>
                      <Form.Control
                        type="text"
                        className="rounded-pill"
                        maxLength={6}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                        }}
                        {...register("pincode", {
                          required: "Pincode is required",
                          pattern: {
                            value: /^[0-9]{6}$/,
                            message: "Pincode must be exactly 6 digits",
                          },
                        })}
                      />

                      {errors?.pincode && (
                        <Form.Text className="text-danger">
                          {errors?.pincode?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row> */}
                {/* <Form.Group className="mb-4">
                  <Form.Check
                    type="checkbox"
                    label="Save this address for delivery of your order"
                    className="form-checkbox"
                    checked={saveAddress}
                    onChange={(e) => setSaveAddress(e.target.checked)}
                  />
                </Form.Group> */}
                {apiError && (
                  <div className="text-danger text-center mb-3">{apiError}</div>
                )}
                <div className="text-center">
                  <WhiteButton
                    title={"Edit Profile"}
                    type="submit"
                    bg="#010E1E"
                    color="#f35f37"
                    hoverColor="#f35f37"
                    hoverBg={"#010E1E"}
                    // onClick={() => navigate("/edit-profile")}
                  />
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>

      {showModal && (
        <SuccessModal
          show={showModal}
          handleClose={() => setShowModal(false)}
        />
      )}
    </section>
  );
};

export default ProfileSettings;
